import React from 'react';

export const VerticalNavigationContext = React.createContext({
  collapse: false,
  rootClassName: ''
});

export const useVerticalNavigationContext = () => React.useContext(VerticalNavigationContext);
